<div class="address-form-container">
  <form #AddressForm="ngForm">
    <label class="contact-select">Customer contact *<select name="CustomerContactID" required [(ngModel)]="Address.CustomerContactID"><option [ngValue]="null">Choose a saved contact</option><option *ngFor="let c of Contacts" [ngValue]="c.CustomerContactID">{{c.FirstName}} {{c.LastName}} · {{c.Email || c.Phone}}</option></select></label><p *ngIf="ContactError" role="alert">{{ContactError}}</p><p>Use the Contacts tab to add a person first. This address will be available with that contact when creating an order.</p>
    <div class="field-row">
      <rms-input name="AddressName" label="Name" [(ngModel)]="Address.AddressName"></rms-input>
      <rms-input name="Street" [required]="true" label="Street" [(ngModel)]="Address.Street"></rms-input>
      <rms-input name="City" [required]="true" label="City" [(ngModel)]="Address.City"></rms-input>
      <rms-input name="State" [required]="true" label="State" [(ngModel)]="Address.State"></rms-input>
      <rms-input name="ZipCode" [required]="true" label="Zip" [(ngModel)]="Address.ZipCode"></rms-input>
      <rms-input name="Country" label="Country" [(ngModel)]="Address.Country"></rms-input>
    </div>
  </form>
  <div class="button-container">
    <button mat-button class="btn-bg-green" [disabled]="!AddressForm.valid" (click)="save()">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>

